"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.en = void 0;
const en = {
  add: 'Add',
  remove: 'Remove',
  error: {
    _: 'Error',
    type: 'Incorrect value, expecting a __type__',
    min: 'Value must be more than __min__',
    max: 'Value must be less than __max__',
    minLength: 'Value must be more than __minLength__ characters long',
    maxLength: 'Value must be less than __maxLength__ characters long',
    required: 'Required',
    minChildren: 'Expected to have at least __minChildren__',
    maxChildren: 'Can only have __maxChildren__'
  }
};
exports.en = en;